import Pricing from "../homepage/homepage_components/pricing/pricing";

export default function PricingPage () {
    return (
        <div>
            <Pricing />
        </div>
    )
}